var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noDescription)?_c('tr',{staticClass:"budget-row-child"},[_c('td',[_vm._v(_vm._s(_vm.name))]),_vm._l((_vm.totals),function(budget,index){return _c('Cell',{key:index + _vm.name,attrs:{"budget":budget}})})],2):_c('RowDescription',{attrs:{"name":_vm.name,"totals":_vm.totals,"description":_vm.child.inc_change_descr}})
}
var staticRenderFns = []

export { render, staticRenderFns }